export default __webpack_public_path__ + "static/dot-bg-d2cd085aac5575f92cd964c18e2cfaee.svg";